'use client'

import { Button, Card, CardContent, Input, TableSettings } from '@repo/ui'
import { TableFilters } from '@repo/ui/components'
import { Plus, Search } from 'lucide-react'
import Link from 'next/link'
import { usePathname, useRouter, useSearchParams } from 'next/navigation'
import { PropsWithChildren, useEffect, useState } from 'react'

const DefaultChildren = () => (
  <Button asChild className={'max-sm::size-10'} variant={'brandOutline'}>
    <Link href={'/quotes/new'}>
      <Plus /> <span className={'font-semibold max-sm:hidden'}>New Quote</span>
    </Link>
  </Button>
)

export const SearchBar = ({ children = DefaultChildren() }: PropsWithChildren) => {
  const [searchTerm, setSearchTerm] = useState<string>('')
  const searchParams = useSearchParams()
  const pathname = usePathname()
  const { replace } = useRouter()

  useEffect(() => {
    const timeout = setTimeout(() => {
      handleSearch(searchTerm)
    }, 400)

    return () => clearTimeout(timeout)
  }, [searchTerm])

  function handleSearch(term: string) {
    const params = new URLSearchParams(searchParams)
    params.delete('page')
    if (term) {
      params.set('search', term)
    } else {
      params.delete('search')
    }
    replace(`${pathname}?${params.toString()}`)
  }

  return (
    <Card>
      <CardContent className={'flex items-center justify-between gap-2'}>
        <div className={'flex items-center gap-2'}>
          <Input
            className={'lg:w-96'}
            defaultValue={searchParams.get('search')?.toString()}
            onChange={e => setSearchTerm(e.target.value)}
            placeholder={'Search here...'}
            startIcon={<Search size={16} />}
          />
          <TableFilters />
          <TableSettings />
        </div>
        {children}
      </CardContent>
    </Card>
  )
}
